import { render, staticRenderFns } from "./matricula.vue?vue&type=template&id=12fa8954&"
import script from "./matricula.vue?vue&type=script&lang=js&"
export * from "./matricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports